import React from "react";
import cn from "classnames";
import StationAutosuggest from "components/StationAutosuggest";
import useLayout from "hooks/useLayout";
import ModalInput from "components/ui/ModalInput";
import "styles/components/station-input.scss";

const StationInput = ({
  className,
  modalClassName,
  location = true,
  placeholder,
  ...props
}) => {
  const { isMobile, isDesktopDevice } = useLayout();

  return isMobile && !(isDesktopDevice) ? (
    <ModalInput
      className={modalClassName}
      inputClassName={cn("otrl-jp__station-input", className)}
      location={location}
      placeholder={placeholder}
      slideUp
      {...props}
    />
  ) : (
    <StationAutosuggest
      className={cn("otrl-jp__station-input", className)}
      location={location}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default StationInput;
